export default __webpack_public_path__ + "static/ringtube-43d880fd86453f53b7c024ca72932321.png";